module.exports = __webpack_public_path__ + "img/add-entity-icon.64e7b9eb.svg";